<template>
    <div class="main">
        <div
            v-for="(contentItem, key) in content"
            :key="key"
        >
            <router-link
                v-if="contentItem.key"
                :to="{ name:'profession-details', params: { professionId: parseInt(contentItem.key) } }"
                class="link"
            >
                <HtmlRenderer
                    :content="contentItem.description"
                    class="item"
                />
            </router-link>
            <HtmlRenderer
                v-else
                :content="contentItem.description"
                class="item"
            />
        </div>

    </div>
</template>

<script>
import HtmlRenderer from '../../../../UI/html-renderer/HtmlRenderer';

export default {
    name: 'MainTestResult',
    components: {
        HtmlRenderer,
    },
    props: {
        content: Array,
    },
};
</script>

<style scoped lang="scss">
    @import '~@/styles/rem';
    @import '~@/styles/mrem';

    .main{
        padding: rem(24) rem(40);

        @include on-mobile {
            padding: mrem(24) mrem(40);
        }

        .item{
            display: block;
            margin-bottom: rem(15);

            @include on-mobile {
                margin-bottom: mrem(15);
            }
        }
        .link{
            font-size: rem(18);

            @include on-mobile {
                font-size: mrem(18);
            }

            &:hover{
                color: #3B5998;
            }
        }
    }
</style>